export default __webpack_public_path__ + "static/media/std-banner.325118ab.png";